import { CASE_CREATE_ACTIONS } from "constants";

export function addCaseEntry() {
    return {
        type: CASE_CREATE_ACTIONS.ADD_CASE_ENTRY
    };
}

export function removeCaseEntry(caseEntryIndex) {
    return {
        type: CASE_CREATE_ACTIONS.REMOVE_CASE_ENTRY,
        payload: {
            caseEntryIndex
        }
    };
}

export function openCase(cases) {
    return {
        type: CASE_CREATE_ACTIONS.OPEN_CASE,
        payload: {
            cases
        }
    };
}

export function updateOpenCase(cases) {
    return {
        type: CASE_CREATE_ACTIONS.UPDATE_OPEN_CASE,
        payload: {
            cases
        }
    };
}

export function successOpenCase(cases) {
    return {
        type: CASE_CREATE_ACTIONS.SUCCESS_OPEN_CASE,
        payload: {
            cases
        }
    };
}

export function failedOpenCase(cases) {
    return {
        type: CASE_CREATE_ACTIONS.FAILED_OPEN_CASE,
        payload: {
            cases
        }
    };
}

export function createCase(caseEntry, contact_detail) {
    return {
        type: CASE_CREATE_ACTIONS.CREATE_CASE,
        payload: {
            caseEntry,
            contact_detail
        }
    };
}
export function createdCase(caseEntry) {
    return {
        type: CASE_CREATE_ACTIONS.CREATED_CASE,
        payload: {
            caseEntry
        }
    };
}
export function failedCreateCase(caseEntry, contact_detail, error) {
    return {
        type: CASE_CREATE_ACTIONS.FAILED_CREATE_CASE,
        payload: {
            caseEntry,
            contact_detail
        },
        error
    };
}

export function resetCaseCreate() {
    return {
        type: CASE_CREATE_ACTIONS.RESET_CASE_CREATE
    };
}

export function createBulkAdhocCase(caseData) {
    return {
        type: CASE_CREATE_ACTIONS.BULK_ADHOC_CASE_CREATE,
        payload: {
            caseData
        }
    };
}
export function createdBulkAdhocCase(caseData, response) {
    return {
        type: CASE_CREATE_ACTIONS.BULK_ADHOC_CASE_CREATED,
        payload: {
            caseData,
            response
        }
    };
}
export function failedCreateBulkAdhocCase(caseData, error) {
    return {
        type: CASE_CREATE_ACTIONS.BULK_ADHOC_CASE_CREATE_FAILED,
        payload: {
            caseData
        },
        error
    };
}

export function createBulkPayProCase(caseData) {
    return {
        type: CASE_CREATE_ACTIONS.BULK_PAYPRO_CASE_CREATE,
        payload: {
            caseData
        }
    };
}
export function createdBulkPayProCase(caseData, response) {
    return {
        type: CASE_CREATE_ACTIONS.BULK_PAYPRO_CASE_CREATED,
        payload: {
            caseData,
            response
        }
    };
}
export function failedCreateBulkPayProCase(caseData, error) {
    return {
        type: CASE_CREATE_ACTIONS.BULK_PAYPRO_CASE_CREATE_FAILED,
        payload: {
            caseData
        },
        error
    };
}